export default "__VITE_ASSET__BKmEA05d__"